import { useEffect } from "react";
import { LoginForm } from "../components/LoginForm";
import { AuthLayout } from "../components/AuthLayout";
import { useNavigate, useSearchParams } from "react-router-dom";
import toast from "react-hot-toast";

export const LoginSignup = () => {
  const user = localStorage.getItem("token");
  const [searchParams] = useSearchParams();
  const verified = searchParams.get("verified");
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      navigate("/");
    }
  }, [user]);

  useEffect(() => {
    if (verified === "true") {
      toast.success("Email verified successfully! You can now log in.", {
        duration: 5000,
      });
    }
  }, []);

  return (
    <AuthLayout>
      <LoginForm />
    </AuthLayout>
  );
};
